import {getWorkbench} from "../getWorkbench";

export function getRecordInfo(ctx: any) {
  return getWorkbench(ctx).recordInfo;
}
